import BalanceIcon from "@mui/icons-material/BalanceOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUpOutlined";
import VerifiedUsercon from "@mui/icons-material/VerifiedUserOutlined";
import SecurityIcon from "@mui/icons-material/SecurityOutlined";

export const benefits = [
  {
    icon: BalanceIcon,
    // icon: <BalanceIcon />,
    title: "Unbiased Recommendations",
    desc: "Choose tools that truly fit your business.",
  },
  {
    icon: TrendingUpIcon,
    // icon: <TrendingUpIcon />,
    title: "Better ROI",
    desc: "Avoid overpaying for unnecessary features.",
  },
  {
    icon: VerifiedUsercon,
    // icon: <VerifiedUsercon />,
    title: "Improved Asset Governance & Control",
    desc: "No vendor lock-in.",
  },
  {
    icon: SecurityIcon,
    // icon: <SecurityIcon />,
    title: "Future-Proof Solutions",
    desc: "Easily evolve with changing needs.",
  },
];

export const comparison = [
  {
    left: "Vendor-neutral approach",
    right: "Tool-biased recommendations",
  },
  {
    left: "Business-first strategy",
    right: "Product-first mindset",
  },
  {
    left: "Flexible & scalable",
    right: "Locked into one ecosystem",
  },
  {
    left: "Long-term partnership",
    right: "One-time implementation",
  },
];
